var config = {
  firebase: {
    apiKey: 'AIzaSyBgk4hKZWc45UKZLV0gHQ_4nxpSNNYw1_U',
    authDomain: 'micondocr-dev.firebaseapp.com',
    databaseURL: 'https://micondocr-dev.firebaseio.com',
    projectId: 'micondocr-dev',
    storageBucket: 'micondocr-dev.appspot.com',
    messagingSenderId: '895365642434'
  },
  reduxFirebase: {
    userProfile: 'users', // root that user profiles are written to
    enableLogging: false, // enable/disable Firebase Database Logging
    updateProfileOnLogin: false // enable/disable updating of profile on login
    // profileDecorator: (userData) => ({ email: userData.email }) // customize format of user profile
  }
}

if (process.env.NODE_ENV === 'production') {
  config.firebase = {
    apiKey: 'AIzaSyAwUnzxPLJCzlksrqOoKedf3F-pWtGWSt8',
    authDomain: 'micondocr.firebaseapp.com',
    databaseURL: 'https://micondocr.firebaseio.com',
    projectId: 'micondocr',
    storageBucket: 'micondocr.appspot.com',
    messagingSenderId: '699020724517'
  }
}

module.exports = config
